import React from 'react';

const termosCliente = `1. O QUE É O BLADE
O BLADE é uma plataforma digital que conecta clientes a barbearias parceiras, facilitando o agendamento e o pagamento de serviços.

2. AGENDAMENTO
Ao agendar um horário, você reserva um atendimento com a barbearia escolhida. O agendamento é confirmado somente após a conclusão do pagamento pelo app.

3. PAGAMENTO
O pagamento é realizado exclusivamente dentro do app, via Pix ou cartão de crédito. Isso garante segurança para você e para a barbearia.

4. CANCELAMENTOS
Cancelamentos devem ser feitos com pelo menos 2 horas de antecedência. Após esse prazo, o reembolso fica sujeito à política de cada barbearia parceira.

5. SEUS DADOS
Seus dados pessoais são utilizados exclusivamente para o funcionamento do serviço BLADE. Não compartilhamos suas informações com terceiros sem o seu consentimento.

6. RESPONSABILIDADE
O BLADE não se responsabiliza pela qualidade dos serviços prestados pelas barbearias, mas disponibiliza canais de avaliação e suporte ao cliente.

7. ALTERAÇÕES
Estes termos podem ser atualizados periodicamente. Você será notificado em caso de mudanças relevantes.

Última atualização: abril de 2025`;

const termosBarbearia = `1. O QUE É O BLADE
O BLADE é uma plataforma digital que conecta clientes a barbearias parceiras, gerenciando agendamentos e pagamentos de forma prática e segura.

2. MODELO DE RECEITA
A plataforma retém uma taxa sobre cada agendamento pago pelo app. Não há mensalidade fixa para a barbearia parceira. O percentual exato da taxa é informado no momento da aprovação do cadastro.

3. APROVAÇÃO DO CADASTRO
O cadastro da barbearia está sujeito à análise e aprovação manual pela equipe BLADE. Reservamo-nos o direito de recusar ou encerrar parcerias que não atendam aos nossos critérios de qualidade.

4. REPASSE DE PAGAMENTOS
Os pagamentos realizados pelos clientes são processados pelo app e repassados à barbearia após a dedução da taxa BLADE, conforme acordado no momento da ativação.

5. RESPONSABILIDADES DA BARBEARIA
A barbearia é integralmente responsável pela qualidade dos serviços prestados, pela conduta de sua equipe e pelo cumprimento dos agendamentos confirmados pelo app.

6. EXIBIÇÃO DE DADOS
As informações cadastradas — nome, endereço, serviços, preços e barbeiros — serão exibidas publicamente para clientes dentro da plataforma BLADE.

7. CANCELAMENTOS PELA BARBEARIA
Em caso de cancelamento de um agendamento confirmado, a barbearia é responsável por comunicar o cliente e, quando aplicável, providenciar o reembolso.

8. ALTERAÇÕES
Estes termos podem ser atualizados. A continuidade de uso da plataforma após notificação implica aceitação dos termos vigentes.

Última atualização: abril de 2025`;

function TermosModal({ tipo, onFechar }) {
  const titulo = tipo === 'barbearia' ? 'Barbearia Parceira' : 'Cliente';
  const conteudo = tipo === 'barbearia' ? termosBarbearia : termosCliente;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.88)',
      display: 'flex', alignItems: 'flex-end',
      zIndex: 3000,
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#181818',
        border: '0.5px solid #2d4a2d',
        borderRadius: '16px 16px 0 0',
        width: '100%',
        maxHeight: '82vh',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 24px 32px'
      }}>

        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontSize: '16px', fontWeight: '700', color: '#e8e8e8', marginBottom: '4px' }}>
            Termos de Uso
          </div>
          <div style={{ fontSize: '10px', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase' }}>
            {titulo}
          </div>
        </div>

        <div style={{
          overflowY: 'auto',
          flex: 1,
          fontSize: '13px',
          color: '#b6b6b6',
          lineHeight: '1.75',
          whiteSpace: 'pre-wrap',
          paddingRight: '4px'
        }}>
          {conteudo}
        </div>

        <button
          onClick={onFechar}
          style={{
            marginTop: '20px',
            width: '100%',
            backgroundColor: '#2d4a2d',
            color: '#7bc47b',
            border: 'none',
            borderRadius: '12px',
            padding: '15px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            fontFamily: 'Arial, sans-serif'
          }}
        >
          Li e entendi
        </button>

      </div>
    </div>
  );
}

export default TermosModal;